import { SERVICE_URL } from "../../config";
import httpCommon from "../../net/http-common";

export const getSingleSmileData = async ({
  smilesName,
}: {
  smilesName: string;
}) => {
  return await httpCommon.post(
    `${SERVICE_URL}/genfil_api/generate_single`,
    {
      smiles: smilesName,
    },
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const getCSVSmilesData = async ({
  SMILESFile,
  smilesColumn,
}: {
  SMILESFile: File;
  smilesColumn: string;
}) => {
  return await httpCommon.post(
    `${SERVICE_URL}/genfil_api/submit`,
    {
      smiles_file: SMILESFile,
      smiles_column: smilesColumn,
    },
    {
      headers: {
        accept: "application/json",
        "Content-Type": "Content-Type: multipart/form-data",
      },
    }
  );
};
